import router from "./index";
import { getToken } from "../utils/token";

router.beforeEach((to) => {
    if (to.meta.public) return true;
    const token = getToken();
    if (!token) return { path: "/login", replace: true };
    return true;
});
